'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const FooterStyled = styled__default["default"].footer.withConfig({
  componentId: "sc-e6thk2-0"
})(_ref => {
  let {
    backgroundColor
  } = _ref;
  return {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: backgroundColor
  };
});
const ButtonWrapper = styled__default["default"].nav.withConfig({
  componentId: "sc-e6thk2-1"
})(["display:flex;width:100%;padding:16px 24px;column-gap:16px;row-gap:8px;box-sizing:border-box;"]);
const Item = styled__default["default"].div.withConfig({
  componentId: "sc-e6thk2-2"
})(["flex-grow:1;display:flex;justify-content:center;"]);
const LeftItem = styled__default["default"](Item).withConfig({
  componentId: "sc-e6thk2-3"
})(["justify-content:end;"]);
const CenterItem = styled__default["default"](Item).withConfig({
  componentId: "sc-e6thk2-4"
})([""]);
const RightItem = styled__default["default"](Item).withConfig({
  componentId: "sc-e6thk2-5"
})(["justify-content:start;"]);
const Divider = styled__default["default"].hr.withConfig({
  componentId: "sc-e6thk2-6"
})(["margin:0;width:100%;border-style:none;border-width:0;", ";"], _ref2 => {
  var _theme$panelcontainer, _theme$panelcontainer2, _theme$panelcontainer3;
  let {
    theme
  } = _ref2;
  return {
    borderTopColor: ((_theme$panelcontainer = theme.panelcontainerNoneNone) === null || _theme$panelcontainer === void 0 ? void 0 : _theme$panelcontainer.borderTopColor) || '#ccc',
    borderTopWidth: ((_theme$panelcontainer2 = theme.panelcontainerNoneNone) === null || _theme$panelcontainer2 === void 0 ? void 0 : _theme$panelcontainer2.borderTopWidth) || '1px',
    borderTopStyle: ((_theme$panelcontainer3 = theme.panelcontainerNoneNone) === null || _theme$panelcontainer3 === void 0 ? void 0 : _theme$panelcontainer3.borderTopStyle) || 'solid'
  };
});

exports.ButtonWrapper = ButtonWrapper;
exports.CenterItem = CenterItem;
exports.Divider = Divider;
exports.FooterStyled = FooterStyled;
exports.LeftItem = LeftItem;
exports.RightItem = RightItem;
